import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import textSlicerFunction, {validateNumChars} from 'notebook/tables/excess/util/textSlicerFunction';

export default {
  ...textSlicerFunction,
  name: 'LEFT',
  shortDescription: 'Substring from the beginning of a specified string.',
  description: 'Returns a substring from the beginning of a specified string.',
  params: [
    {
      ...textSlicerFunction.params[0],
      description: 'The string from which the right portion will be returned.',
    },
    {
      ...textSlicerFunction.params[1],
      description:
        'The number of characters to return from the left side of string. Equals 1 if not specified.',
    },
  ],
  eval: (text: string, numChars?: number): string => {
    validateNumChars('LEFT', numChars);
    numChars ??= 1;
    return text.slice(0, numChars);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
